export interface AccountUpdateSecurityResponse {
  EntityID: string;
  Message: string;
}
